// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3kacl","overflowing":"ReadFullNote_overflowing__LaFNq"};